// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".apc-top-container .activity-flow {\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  margin-left: 15px;\n}", ""]);
// Exports
module.exports = exports;
